<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color bg-wite">

          <div class="vx-row no-gutter justify-center items-center ">

            <div class="vx-col hidden lg:block lg:w-1/2 px-4 py-10 color-bg-login min-h-login">
              <img class="mb-5 max-w-logo d-block m-auto" src="@/assets/images/logo/logo-full.svg" alt="registerImg">
              <img src="@/assets/images/pages/sms.svg" alt="login" class="mx-auto">
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="p-8 login-tabs-container py-login">

                <div class="vx-card__title mb-4">
                  <h4 class="mb-4">Verificación de teléfono</h4>
                  <p>Hemos enviado un código al número: <br> <b>{{ phone }}</b>.</p>
                  <a @click="toggleTab(1)" style="cursor: pointer">Reintentar con otro número</a>
                </div>

                <div>

                  <vs-input
                    label-placeholder="Código"
                    name="code"
                    icon-no-border
                    icon="icon icon-smartphone"
                    icon-pack="feather"
                    v-model="code"
                    class="w-full"/>

                  <br>
                  <vs-button :disabled="isSubmitted" @click="submitCode">Enviar</vs-button>

                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import {mapActions} from "vuex";
import router from "@/router";

export default {
  name: "SmsVerificationCode",
  props: ['toggleTab', 'phone'],
  data() {
    return {
      code: "",
      isSubmitted: false
    }
  },
  methods: {
    ...mapActions('account', ['smsVerificationCode']),
    submitCode() {
      const {code} = this;
      if (code && code.length === 6) {
        this.isSubmitted = true;
        this.smsVerificationCode({code, phone: this.phone.replace(/\s+/g, '')})
          .then(
            () => {
              this.$store.dispatch("account/me", {aclChangeRole: this.$acl.change})
              .then(() => {
                this.isSubmitted = false;
                router.push("/")
              });
            }
          )
        .catch(() => this.isSubmitted = false)
      } else {
        this.$vs.notify({title:'Error',text:"Ingrese los datos requeridos y verifica que el codigo sea de 5 dígitos", color: 'danger', position:'bottom-center'})
      }
    }
  }
}
</script>

<style scoped>

</style>
